import { useState } from 'react';
import styled, { keyframes, css } from 'styled-components';

const bounceAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.94);
  }
  100% {
    transform: scale(1);
  }
`;

const SquishyButton = styled.div`
  width: ${({ $fullWidth }) => ($fullWidth !== false ? '100%' : 'auto')};
  display: ${({ $fullWidth }) => ($fullWidth !== false ? 'block' : 'inline-block')};
  touch-action: pan-y;
  cursor: pointer;
  transform-origin: center;
  will-change: transform;
  ${({ $isAnimating }) =>
    $isAnimating &&
    css`
      animation: ${bounceAnimation} 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
    `}
`;

const Bounceable = ({ children, onClick, fullWidth = true, ...props }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    }

    // Play animation
    setIsAnimating(true);
    setTimeout(() => {
      setIsAnimating(false);
    }, 200);
  };

  return (
    <SquishyButton
      $fullWidth={fullWidth}
      onClick={handleClick}
      $isAnimating={isAnimating}
      {...props}
    >
      {children}
    </SquishyButton>
  );
};

export default Bounceable;
